export default "__VITE_ASSET__CnUk1GjJ__"